import React, { Component } from 'react';
import {
  arrayOf,
  shape,
  string,
} from 'prop-types';
import _ from 'lodash';
import { withRouter } from 'react-router';
import withApplicationConfig from 'containers/withApplicationConfig';
import { Block, Button } from 'components/common';

import './CompareOtherProductsPanel.scss';

class CompareOtherProductsPanel extends Component {
  static propTypes = {
    categories: arrayOf(shape({})),
    vertical: string,
    language: string.isRequired,
    resultsPageRouteWithList: string,
    labels: shape({
      title: string,
      subtitle: string,
      compare: string,
    }),
  };

  static defaultProps = {
    categories: [],
    labels: {},
    vertical: '',
    resultsPageRouteWithList: '',
  };

  constructor(props) {
    super(props);

    const { categories } = props;

    // the isDefault property is missing in the data
    // so setting first object as default value
    const defaultCategory = _.first(categories.filter(category => category.isDefault
      || category.urlAlias));

    this.state = {
      selectedCategoryId: defaultCategory.urlAlias,
    };

    this.onSelectChange = this.onSelectChange.bind(this);
    this.onCompareButtonClick = this.onCompareButtonClick.bind(this);
  }

  onSelectChange({ value }) {
    if (value) {
      this.setState({
        selectedCategoryId: value,
      });
    }
  }

  onCompareButtonClick() {
    const { selectedCategoryId } = this.state;
    const {
      language,
      vertical,
      resultsPageRouteWithList,
    } = this.props;

    const compareCardsPage = _.template(resultsPageRouteWithList);
    const compareCardPageRoute = compareCardsPage({
      language,
      vertical,
      list: selectedCategoryId,
    });
    const route = `${compareCardPageRoute}?from=ccpr`;

    // TODO: Use server side routing for now
    window.location.href = route;
    // history.push(route);
  }

  render() {
    const {
      categories,
      labels = {},
    } = this.props;
    const { selectedCategoryId } = this.state;

    return (
      <Block>
        <Block.Header
          title={labels.title}
          subtitle={labels.subtitle}
        />
        <div className="compare-other-products-panel">
          <div className="container-wrapper">
            <div className="row-wrapper">
              <div className="col-wrapper">
                <div className="select-product-wrapper">
                  <Button
                    as="select"
                    tertiary
                    fluid
                    value={selectedCategoryId}
                    options={categories.map(({ title, urlAlias }) => ({
                      label: title.display,
                      value: urlAlias,
                    }))}
                    onChange={this.onSelectChange}
                  />
                </div>
                <div className="compare-button-wrapper">
                  <Button
                    fluid
                    onClick={this.onCompareButtonClick}
                  >
                    {labels.compare}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Block>
    );
  }
}

export default withRouter(withApplicationConfig(CompareOtherProductsPanel, 'routes'));
